<template>
  <div class="menu-box">
    <div class="menu-item" v-for="(item, index) in menuList" :key="index">
      <template v-if="item.webArticleColumnEntities">
        <a class="menu__title" :class="{'arrow': !item?.webArticleColumnEntities.length}" @click="item?.webArticleColumnEntities.length ? null : toPage(item)">{{ item.name }}
          <i class="el-icon-arrow-down" v-if="item?.webArticleColumnEntities.length"></i>
        </a>
        <div class="sub-menu"  v-if="item?.webArticleColumnEntities.length">
          <template v-for="(sub, sindex) in item.webArticleColumnEntities">
            <a  :key="sindex" @click="toPage(sub)">{{
              sub.name
            }}</a>
          </template>
        </div>
      </template>
    </div>
    <!-- <div class="flex_row_center">
      <el-input
        style="width: 120px"
        placeholder=""
        suffix-icon="el-icon-search"
        v-model="input"
      >
      </el-input>
    </div> -->
  </div>
</template>

<script>
import {getHeaderMenu} from '@/api/companyConsult'
export default {
  components: {},
  props: {},
  data() {
    return {
      menuList: [],
      input:''
    };
  },
  created() {
    this.getHeaderMenu()
  },
  methods: {
    //跳转页面
    toPage(row){
      if(this.$route.query.id === row.id || !row.id) return 
      this.$router.push({
        path: '/module/module-text',
        query: {
          type: row.type,
          id: row.id,
          title: row.name
        }
      })
    },
    getHeaderMenu(){
        getHeaderMenu().then(res=>{
            if(res.columnEntityList){
                this.menuList = res.columnEntityList
            }
        }).catch(err => {
          console.error('获取头部菜单失败:', err)
        })

    }
  },
};
</script>

<style lang="less" scoped>
::v-deep .el-input--suffix .el-input__inner{
  border-radius: 26px;
}
 .menu-box {
  position: relative;
  width: 100%;

  display: flex;
  justify-content: space-evenly;
  gap: 20px;

  .menu-item {
    position: relative;
    display: flex;
    align-items: center;
    transition-duration: 0.6s;
    .arrow{
      cursor: pointer;
    }
    .menu__title {
      font-size: 18px;
      font-weight: 400;
      line-height: 34px;
      text-align: center;
      color: #3d3d3d;
      display: block;
      z-index: 1;

      .el-icon-arrow-down {
        transition: transform 0.3s ease;
        margin-left: 5px;
      }
    }

    .sub-menu {
      position: absolute;
      min-width: 160px;
      height: auto;
      padding: 0;
      max-height: 0;
      background: #3d3d3db3;
      top: 94px;
      left: 50%;
      z-index: 9999;
      margin-left: -80px;
      overflow: hidden;
      transition: all 0.3s ease;
      backdrop-filter: blur(10px);
      border-radius: 0 0 10px 10px;

      a {
        display: block !important;
        width: 100%;
        height: 45px;
        margin: 0 auto;
        padding: 0 20px;
        font-size: 17px;
        font-weight: 400;
        line-height: 44px;
        color: #fff;
        text-align: center;
        white-space: nowrap;
        transition: all .4s ease-in-out;

        &:hover {
          // border-bottom: 1px solid #fff;
          color: #3d3d3d;
          background-color: #fff;
        }
      }
    }

    &:hover:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-bottom: 8px solid var(--theme-color);
      bottom: 0;
    }

    &:not(:has(.el-icon-arrow-down)):hover:before {
      display: none;
    }

    &:hover {
      .sub-menu {
        padding: 20px 0;
        max-height: 800px;
        cursor: pointer;
      }

      .menu__title {
        .el-icon-arrow-down {
          transform: rotate(180deg);
        }
      }

      .menu__title:after {
        transform: translateY(25%) rotate(180deg) !important;
      }
    }
  }
}
</style>
